import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex-shrink-0 print:hidden"
};
const _hoisted_2 = {
  class: "pb-4 pt-2"
};
const _hoisted_3 = {
  class: "rounded-lg bg-gray-50 p-4"
};
const _hoisted_4 = {
  class: "print:hidden"
};
const _hoisted_5 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_6 = {
  class: "flex items-center gap-4"
};
const _hoisted_7 = {
  key: 0,
  style: {
    "margin": "4px 12px",
    "border": "0",
    "border-top": "1px solid #e0e0e0"
  }
};
const _hoisted_8 = {
  class: "flex items-center gap-2"
};
const _hoisted_9 = {
  class: "px-6 py-3 bg-gray-50 border-gray-200 flex items-center justify-between print:hidden"
};
const _hoisted_10 = {
  class: "flex items-center gap-3"
};
const _hoisted_11 = {
  class: "normal-table-container"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "font-semibold text-gray-900 text-sm"
};
const _hoisted_15 = {
  key: 0,
  class: "flex items-center justify-end gap-1"
};
const _hoisted_16 = {
  key: 1,
  class: "text-gray-400 flex justify-end"
};
const _hoisted_17 = {
  key: 0,
  class: "font-medium text-gray-900 text-sm"
};
const _hoisted_18 = {
  key: 1,
  class: "text-gray-400"
};
const _hoisted_19 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_20 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_21 = {
  class: "text-gray-900 text-sm font-medium"
};
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-1 whitespace-nowrap text-xs text-amber-700",
  "data-cy": "fixed-fee-row-error"
};
const _hoisted_23 = {
  class: "text-gray-600 font-mono text-xs"
};
const _hoisted_24 = ["aria-label"];
const _hoisted_25 = {
  class: "text-center"
};
const _hoisted_26 = {
  key: 0,
  class: "text-gray-400"
};
const _hoisted_27 = {
  class: "text-gray-700"
};
const _hoisted_28 = {
  class: "text-gray-700 font-mono text-sm"
};
const _hoisted_29 = {
  class: "text-gray-700 font-mono text-sm"
};
const _hoisted_30 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_31 = {
  class: "text-gray-700 text-sm"
};
const _hoisted_32 = {
  class: "p-8"
};
const _hoisted_33 = {
  class: "text-center py-16"
};
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import RouteService from '@/services/RouteService';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlUserAvatar from '@/components/LlUserAvatar.vue';
import LlStatusBadge from '@/components/LlStatusBadge.vue';
import FixedFeesFilters from './FixedFeesFilters.vue';
import FixedFeeEditPanel from './FixedFeeEditPanel.vue';
import MetabaseDashboard from '@/components/MetabaseDashboard.vue';
import ChangeMatterDialog from '@/components/ChangeMatterDialog.vue';
import { formatCurrency, formatOrDefault, getShortDateString, pluralizeWithCount } from '@/services/utils';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useEntryProcessState } from '@/composables/useEntryProcessState';
import DeleteRecurringFeesDialog from './components/DeleteRecurringFeesDialog.vue';
import { useFixedFeesFilters } from './useFixedFeesFilters';
import { useFixedFeeDashboard } from './useFixedFeeDashboard';
import { formatStatus, formatBilledStatus, formatChargeType, getProfitabilityColor, getStatusColor, getCompletionColor, formatPercentage } from './formatters';
import { CompletionState, BulkUpdateType, TIME_LOCK_COLUMN_ID } from './constants';
import FixedFeeBulkActionsMenu from './components/FixedFeeBulkActionsMenu.vue';
import FixedFeeWipDispositionDialog from './components/FixedFeeWipDispositionDialog.vue';
import { canLockUnlockTime as lockGateOpen, isTimeLockVisible as timeLockVisible } from './utils/fixedFeeLockGate';
import LlTooltip from '@/components/LlTooltip.vue';
import LlIcon from '@/components/LlIcon.vue';
import { TrackingCategory, TrackingAction, TrackingPageType } from '@/constants/trackingConstants';
import ChargeService from '@/services/ChargeService';
import EventTracker from '@/services/eventTracker';
export default {
  __name: 'FixedFeesTable',
  props: {
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    },
    snippetService: {
      type: Object,
      required: false
    },
    entryEditService: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    clientMatterManager: {
      type: Object,
      required: false
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    // Deep linking: null when no panel, object with chargeId/matterId when panel should open
    routePanelParams: {
      type: Object,
      default: null
    }
  },
  emits: ['panel-closed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Composables
    const {
      filters: filterState,
      queryParams,
      metabaseFilters,
      activeFilterCount
    } = useFixedFeesFilters();
    const hasActiveFilters = computed(() => activeFilterCount.value > 0);

    // Metabase Dashboard Composable
    const {
      selectedDashboardId,
      showMetabaseDashboard
    } = useFixedFeeDashboard();
    const dashboardFilters = metabaseFilters;

    // Stores
    const chargesStore = useChargesStore();
    const meStore = useMeStore();
    const {
      permissions,
      me,
      company,
      settings,
      features
    } = storeToRefs(meStore);

    // Alerts
    const {
      handleError,
      handleSuccess,
      handleWarning
    } = useSnackbarHandler();
    const {
      handleResult,
      getState: getRowState,
      clear: clearRowErrors
    } = useEntryProcessState();

    // Reactive State
    const charges = ref([]);
    const loading = ref(false);
    const exportLoading = ref(false);
    const selectedItems = ref([]);
    // `loading` only covers loadCharges, so the menu would stay live during the POST.
    const bulkLockLoading = ref(false);

    // Deletion state
    const deleteConfirmRef = ref(null);
    const deleteRecurringRef = ref(null);

    // Panel state
    const showEditPanel = ref(false);
    const selectedChargeId = ref(null);
    const selectedMatterId = ref(null);
    const closeTimeout = ref(null);
    const filtersVisible = ref(true);
    const editPanelRef = ref(null);

    // Helper to clear pending timeout (defined before watcher that uses it)
    const clearPendingTimeout = () => {
      if (closeTimeout.value) {
        clearTimeout(closeTimeout.value);
        closeTimeout.value = null;
      }
    };

    // Watch for panel deep link from route params
    watch(() => props.routePanelParams, panelParams => {
      if (panelParams) {
        clearPendingTimeout();
        selectedChargeId.value = panelParams.chargeId;
        selectedMatterId.value = panelParams.matterId;
        showEditPanel.value = true;
      } else if (showEditPanel.value) {
        // URL was cleared externally (e.g., back button), close panel
        showEditPanel.value = false;
        clearPendingTimeout();
      }
    }, {
      immediate: true
    });

    // Open panel and update URL for deep linking without triggering route change
    // Uses notify: false to prevent filter resets and table reloads
    const openPanel = async chargeId => {
      // Check if we're switching to a different charge while panel is open
      const isDifferentCharge = chargeId !== selectedChargeId.value;
      if (showEditPanel.value && isDifferentCharge) {
        // Check for unsaved changes before switching
        if (editPanelRef.value?.confirmDiscardChanges) {
          const proceed = await editPanelRef.value.confirmDiscardChanges('selecting another fixed fee');
          if (!proceed) {
            return; // User chose to keep editing
          }
        }

        // Close and reopen with new charge
        showEditPanel.value = false;
        await nextTick();
      }
      clearPendingTimeout();
      selectedChargeId.value = chargeId || null;
      selectedMatterId.value = null;
      showEditPanel.value = true;

      // Update URL for deep linking without triggering route change (notify: false)
      if (chargeId && props.state?.go) {
        props.state.go('fixedfees', {
          chargeId,
          panel: true
        }, {
          notify: false,
          reload: false
        });
      }
    };
    const handleRowClick = async (event, {
      item
    }) => {
      // Prevent opening panel when clicking action buttons, checkboxes, or links
      const target = event.target;
      const isActionClick = target.closest('button') || target.closest('.v-selection-control') || target.closest('a') || target.closest('.v-checkbox') || target.closest('.v-data-table__td--select');
      if (isActionClick) return;
      await openPanel(item.chargeId);
    };
    const getRowProps = ({
      item
    }) => {
      return {
        class: item.chargeId === selectedChargeId.value ? 'active-row' : '',
        'data-cy': `fixed-fee-row-${item.chargeId}`
      };
    };
    const deletionState = reactive({
      loading: false,
      deleting: false,
      totalCount: 0,
      feesWithEntriesCount: 0,
      billedCount: 0,
      previewData: null
    });

    // Completion state
    const completionConfirmRef = ref(null);
    const wipDispositionRef = ref(null);
    const lockConfirmRef = ref(null);
    const pendingLockAction = ref(true);
    const incompletionConfirmRef = ref(null);

    // Change matter state
    const showChangeMatterDialog = ref(false);
    const changeMatterForm = ref({
      client: null,
      matter: null
    });
    const changeMatterConfirmRef = ref(null);
    const changeMatterState = reactive({
      requiresConfirmation: false,
      totalUnbilledEntryCount: 0,
      chargesWithUnbilledEntries: []
    });

    // Column visibility state
    const availableColumns = ref([]);
    const defaultColumns = ref([]);
    const visibleColumnIds = ref([]);
    const saveTimeout = ref(null);
    const columnsBeforeToggle = ref(null); // Snapshot for tracking column customization changes

    // Pagination state matching Time.vue pattern
    const currentPage = ref(1);
    const pageSize = ref(50); // Match Time.vue default
    const totalCount = ref(0);

    // Sorting state
    const sortBy = ref([]);

    // Computed
    const companyId = computed(() => {
      // Company ID is stored in me.company.id based on useMeStore structure
      const id = me.value?.company?.id || '';
      return id;
    });
    const canViewRates = computed(() => permissions.value?.time?.viewRates || false);
    const ledesEnabled = computed(() => company.value?.settings?.ledes?.enabled || false);
    const customFlagLabel = computed(() => company.value?.settings?.labels?.customFlag || null);

    // The flipper gates every part of Lock/Unlock Time, including the bulk bar's
    // move to a More actions menu.
    const fixedFeeTimeLockEnabled = computed(() => features.value?.fixedFeeTimeLock === true);

    // Gates and their reasoning live in utils/fixedFeeLockGate.
    const canLockUnlockTime = computed(() => lockGateOpen({
      features: features.value,
      companySettings: company.value?.settings,
      permissions: permissions.value
    }));

    // Reading the status is not the same as changing it: a user without the
    // Lock/Unlock permission still sees the column (BR-021 gates on the firm, not
    // the user).
    const showTimeLockColumn = computed(() => timeLockVisible({
      features: features.value,
      companySettings: company.value?.settings
    }));
    const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value));

    // Dynamic table height based on filters and row count
    const tableHeight = computed(() => {
      if (charges.value.length <= 10) return 'auto';
      return filtersVisible.value ? '50vh' : '65vh';
    });

    // Deletion confirmation message
    const deletionConfirmMessage = computed(() => {
      if (deletionState.loading) {
        return 'Loading deletion preview...';
      }
      let message = `Are you sure you want to delete ${deletionState.totalCount} fixed fee(s)? This action cannot be undone.`;
      if (deletionState.feesWithEntriesCount > 0) {
        message += `\n${deletionState.feesWithEntriesCount} fixed fee(s) have time entries associated. The time entries will be unassigned from their fixed fees as a result.`;
      }
      if (deletionState.billedCount > 0) {
        message += `\n\nNote: ${deletionState.billedCount} billed fixed fee(s) cannot be deleted and will be skipped.`;
      }
      return message;
    });

    // Handle sort changes from v-data-table
    const handleSortChange = newSort => {
      if (!newSort || newSort.length === 0) return;

      // Only update if sort actually changed
      const newKey = newSort[0]?.key;
      const newOrder = newSort[0]?.order;
      if (sortBy.value[0]?.key !== newKey || sortBy.value[0]?.order !== newOrder) {
        const previousColumn = sortBy.value[0]?.key || null;
        sortBy.value = newSort;
        currentPage.value = 1; // Reset to first page
        loadCharges();

        // Track column sort event
        if (props.tracking) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_LIST, TrackingAction.COLUMN_SORTED, {
            columnName: newKey,
            sortDirection: newOrder,
            previousColumn: previousColumn !== newKey ? previousColumn : null,
            pageType: TrackingPageType.FIXED_FEE_LIST
          });
        }
      }
    };
    // Completion confirmation message
    const completionConfirmMessage = computed(() => {
      return 'Are you sure you want to mark selected fixed fees as completed?\n\nNote: Fees with billed status and date-based fixed fees will not be updated.';
    });

    // Incompletion confirmation message
    const incompletionConfirmMessage = computed(() => {
      return 'Are you sure you want to mark selected fixed fees as incomplete?\n\nNote: Fees with billed status and date-based fixed fees will not be updated.';
    });

    // Change matter confirmation message
    const changeMatterConfirmMessage = computed(() => {
      if (changeMatterState.totalUnbilledEntryCount === 0) return '';
      const entryCount = changeMatterState.totalUnbilledEntryCount;
      const chargeCount = changeMatterState.chargesWithUnbilledEntries.length;
      const chargeText = chargeCount === 1 ? 'This fixed fee has' : `These ${pluralizeWithCount(chargeCount, 'fixed fee')} have`;
      const entryText = entryCount === 1 ? '1 unbilled time entry' : `${entryCount} unbilled time entries`;
      return `${chargeText} ${entryText}.

If you proceed:
• Time entries will move to the new client/matter
• Billing rates will update based on the new matter's rate table
• Fixed fee association will be maintained

Do you want to continue?`;
    });

    // Column visibility initialization
    const initializeColumnSettings = async () => {
      try {
        // Ensure user data is loaded
        await meStore.getMe();

        // Fetch available columns from /columns endpoint (for permission filtering)
        const columnData = await meStore.getFixedFeeColumns();
        if (columnData) {
          availableColumns.value = columnData.columns || [];
          defaultColumns.value = columnData.defaults || [];
        }

        // Get saved preferences from settings (reactive ref from storeToRefs)
        const savedColumns = settings.value?.fixedFeeTableColumns?.visibleColumns;

        // Initialize visible columns: prioritize saved preferences, fallback to defaults
        if (savedColumns !== null && savedColumns !== undefined && Array.isArray(savedColumns)) {
          // User has saved preferences - use those
          visibleColumnIds.value = [...savedColumns];
        } else {
          // No saved preferences - use defaults from /columns endpoint
          visibleColumnIds.value = [...defaultColumns.value];
        }
      } catch (error) {
        console.error('Failed to initialize column settings:', error);
        // Fallback to hardcoded defaults on error
        visibleColumnIds.value = ['invoiceUser', 'client', 'matter', 'completeStatus', 'createdDate'];
      }
    };

    // Check if a column is currently visible
    const isColumnVisible = columnId => {
      return visibleColumnIds.value.includes(columnId);
    };

    // Get dynamic column label (override customCheckbox with dynamic label)
    const getColumnLabel = column => {
      if (column.id === 'customCheckbox' && customFlagLabel.value) {
        return customFlagLabel.value;
      }
      return column.label;
    };

    // Toggle column visibility with debounced save
    const toggleColumn = async (columnId, visible) => {
      // Capture snapshot before first toggle in a batch (no pending save)
      if (!saveTimeout.value) {
        columnsBeforeToggle.value = [...visibleColumnIds.value];
      }

      // Update local state immediately for responsive UI
      if (visible) {
        if (!visibleColumnIds.value.includes(columnId)) {
          visibleColumnIds.value.push(columnId);
        }
      } else {
        visibleColumnIds.value = visibleColumnIds.value.filter(id => id !== columnId);
      }

      // Clear existing timeout
      if (saveTimeout.value) {
        clearTimeout(saveTimeout.value);
      }

      // Debounce save (300ms like time entries)
      saveTimeout.value = setTimeout(async () => {
        saveTimeout.value = null;
        const snapshotBefore = columnsBeforeToggle.value;
        const snapshotAfter = [...visibleColumnIds.value];
        columnsBeforeToggle.value = null;
        try {
          await meStore.updateFixedFeeColumns(snapshotAfter);

          // Track column customization event after successful save
          if (snapshotBefore && props.tracking) {
            const previousSet = new Set(snapshotBefore);
            const currentSet = new Set(snapshotAfter);
            const columnsAdded = snapshotAfter.filter(c => !previousSet.has(c));
            const columnsRemoved = snapshotBefore.filter(c => !currentSet.has(c));
            // Only fire event if there are actual changes
            if (columnsAdded.length > 0 || columnsRemoved.length > 0) {
              EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_LIST, TrackingAction.COLUMNS_UPDATED, {
                columnsAdded,
                columnsRemoved,
                totalColumns: snapshotAfter.length,
                pageType: TrackingPageType.FIXED_FEE_LIST
              });
            }
          }
        } catch (error) {
          console.error('Failed to save column preferences:', error);
          // Revert to saved state on error
          await initializeColumnSettings();
        }
      }, 300);
    };

    // Required Headers (always visible per story AC)
    const requiredHeaders = [{
      title: 'Billable Date',
      value: 'chargeDate',
      sortable: true,
      width: 20
    }, {
      title: 'Description',
      value: 'description',
      sortable: true,
      width: 50
    }, {
      title: 'Amount',
      value: 'amount',
      sortable: true,
      align: 'end',
      width: 20
    }];

    // Separate columns into enabled (currently visible) and disabled for menu display
    // Note: availableColumns from API is filtered for permissions and for the LEDES
    // and custom-flag settings, but not for the Time Lock firm setting — the
    // endpoint does not know about it, so that one is filtered here.
    // Optimized: Single iteration instead of two separate filters (O(n) vs O(2n))
    const columnLists = computed(() => {
      const enabled = [];
      const disabled = [];
      const requiredColumnIds = requiredHeaders.map(h => h.value); // Derive from requiredHeaders

      for (const col of availableColumns.value) {
        if (requiredColumnIds.includes(col.id)) continue;
        if (col.id === TIME_LOCK_COLUMN_ID && !showTimeLockColumn.value) continue;

        // Direct array check instead of function call for better performance
        if (visibleColumnIds.value.includes(col.id)) {
          enabled.push(col);
        } else {
          disabled.push(col);
        }
      }
      return {
        enabled,
        disabled
      };
    });
    const enabledColumnsList = computed(() => columnLists.value.enabled);
    const disabledColumnsList = computed(() => columnLists.value.disabled);

    // Optional Headers (per story AC - can be toggled)
    const optionalHeaders = computed(() => [{
      title: 'Created Date',
      value: 'createdDate',
      columnId: 'createdDate',
      sortable: true,
      canToggle: true,
      width: 20
    }, {
      title: 'Label',
      value: 'label',
      columnId: 'label',
      sortable: true,
      canToggle: true,
      width: 30
    }, {
      title: 'Client',
      value: 'clientName',
      columnId: 'client',
      sortable: true,
      canToggle: true,
      width: 180
    }, {
      title: `${me.value?.terms?.Matter || 'Matter'}`,
      value: 'matterName',
      columnId: 'matter',
      sortable: true,
      canToggle: true,
      width: 180
    }, {
      title: 'Activity Code',
      value: 'activityCode',
      columnId: 'activityCode',
      sortable: true,
      canToggle: ledesEnabled.value,
      reason: ledesEnabled.value ? '' : 'LEDES not enabled',
      width: 20
    }, {
      title: 'Task Code',
      value: 'taskCode',
      columnId: 'taskCode',
      sortable: true,
      canToggle: ledesEnabled.value,
      reason: ledesEnabled.value ? '' : 'LEDES not enabled',
      width: 20
    }, {
      title: 'Type',
      value: 'chargeType',
      columnId: 'type',
      sortable: true,
      canToggle: true,
      width: 50
    }, {
      title: 'Complete Status',
      value: 'completionState',
      columnId: 'completeStatus',
      sortable: true,
      canToggle: true,
      width: 30
    }, {
      title: 'Billed Status',
      value: 'billedState',
      columnId: 'billedStatus',
      sortable: true,
      canToggle: true,
      width: 20
    },
    // Adjacent to Billed Status and never merged with it: a fee has two
    // independent facts, and merging them loses "Billed but still open" —
    // the state this feature exists to create (BR-019).
    {
      title: 'Time Lock Status',
      value: 'timeLocked',
      columnId: 'timeLocked',
      sortable: true,
      canToggle: true,
      width: 20
    }, {
      title: customFlagLabel.value || 'Custom',
      value: 'customFlag',
      columnId: 'customCheckbox',
      sortable: true,
      canToggle: true,
      width: 80
    }, {
      title: 'Profitability',
      value: 'profitability',
      columnId: 'profitabilityPercentage',
      sortable: true,
      canToggle: canViewRates.value,
      reason: canViewRates.value ? '' : 'No permission',
      align: 'end',
      width: 20
    }, {
      title: 'Profit',
      value: 'profitabilityAmount',
      columnId: 'profitabilityAmount',
      sortable: true,
      canToggle: canViewRates.value,
      reason: canViewRates.value ? '' : 'No permission',
      align: 'end',
      width: 20
    }, {
      title: 'Hours',
      value: 'hours',
      columnId: 'hours',
      sortable: true,
      canToggle: true,
      align: 'end',
      width: 20
    }, {
      title: 'Invoice User',
      value: 'invoiceUser',
      columnId: 'invoiceUser',
      sortable: true,
      canToggle: true,
      width: 80
    }, {
      title: 'Matter Reference',
      value: 'matterReference',
      columnId: 'matterReference',
      sortable: true,
      canToggle: true,
      width: 10
    }]);

    // Visible Headers - filter based on user's column visibility preferences AND current permissions
    const visibleHeaders = computed(() => {
      // Start with required headers (always visible)
      const headers = [...requiredHeaders];

      // Add optional headers if they're in the visible column IDs AND available (permission-filtered)
      optionalHeaders.value.forEach(header => {
        // The backend still serves this column to firms that never opted in, so the
        // flipper and the firm setting are checked here rather than left to it.
        if (header.columnId === TIME_LOCK_COLUMN_ID && !showTimeLockColumn.value) {
          return;
        }

        // Find matching column by columnId (backend ID)
        const column = availableColumns.value.find(col => col.id === header.columnId);

        // Include header only if column exists AND is visible in preferences
        if (column && isColumnVisible(column.id)) {
          headers.push(header);
        }
      });

      // Add actions column at the end
      headers.push({
        title: '',
        value: 'actions',
        sortable: false,
        width: 50
      });
      return headers;
    });

    // Methods
    const buildTableParams = () => {
      const params = {
        ...queryParams.value,
        // Spread filter params (including custom fields)
        pageSize: pageSize.value,
        page: currentPage.value
      };
      if (sortBy.value && sortBy.value.length > 0) {
        params.orderBy = sortBy.value[0]?.key;
        params.sortAscending = sortBy.value[0]?.order === 'asc';
      }
      return params;
    };
    const loadCharges = async () => {
      loading.value = true;
      clearSelection();
      try {
        const response = await chargesStore.loadChargesTable(buildTableParams());

        // The API returns nested structure: {data: {items: [], count: 99}}
        if (response && response.data && response.data.items && Array.isArray(response.data.items)) {
          charges.value = mapChargesData(response.data.items);
          totalCount.value = response.data.count || 0;
        }
        // Fallback for direct array in data
        else if (response && response.data && Array.isArray(response.data)) {
          charges.value = mapChargesData(response.data);
          totalCount.value = response.totalCount || 0;
        } else {
          charges.value = [];
          totalCount.value = 0;
        }
      } catch (error) {
        charges.value = [];
        totalCount.value = 0;
      } finally {
        loading.value = false;
      }
    };

    // Map API response fields to component expected fields
    const mapChargesData = items => {
      const today = new Date().toISOString();
      return items.map(item => ({
        ...item,
        // Rename fields for table display
        customFlag: item.customFlag || false,
        invoiceUser: item.account?.name,
        invoiceUserInitials: item.account?.initials,
        // Date handling: Use today's date for sorting when null, but preserve original for display
        chargeDate: item.chargeDate || today,
        chargeDateDisplay: item.chargeDate // Original value for display (can be null)
      }));
    };
    let searchTimeout;
    const handleSearch = value => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        currentPage.value = 1;
        filterState.value.search = value;
        loadCharges();
      }, 300);
    };

    // Cleanup
    onBeforeUnmount(() => {
      if (searchTimeout) clearTimeout(searchTimeout);
    });

    // Filter handlers
    const handleApplyFilters = emittedFilters => {
      // Update filterState with the emitted filters from child component
      if (emittedFilters) {
        // Preserve the current search value before applying filters
        const currentSearch = filterState.value.search;
        Object.assign(filterState.value, emittedFilters);
        // Always preserve search - filters shouldn't clear the search box
        filterState.value.search = currentSearch;
      }
      currentPage.value = 1;
      loadCharges();
    };
    const handleClearFilters = () => {
      // Filter reset is handled in FixedFeesFilters component
      currentPage.value = 1;
      loadCharges();
    };
    const handleFiltersVisibilityChanged = visible => {
      filtersVisible.value = visible;
    };

    // Navigation
    const routeService = new RouteService(props);
    const goToClient = clientId => {
      if (!clientId) return;
      trackClientMatterLinkClick('client', clientId);
      routeService.go('clients.client.view.overview', {
        id: clientId
      });
    };
    const goToMatter = (clientId, matterId) => {
      if (!clientId || !matterId) return;
      trackClientMatterLinkClick('matter', matterId);
      routeService.go('matters-next.client.matter.overview', {
        id: clientId,
        matterId
      });
    };
    const trackClientMatterLinkClick = (linkType, linkId) => {
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.CLIENT_MATTER_LINK, TrackingAction.CLICKED, {
          linkType,
          linkId,
          pageType: TrackingPageType.FIXED_FEE_LIST
        });
      }
    };

    // Actions
    const viewDetails = async item => {
      if (!item?.chargeId) return;
      await openPanel(item.chargeId);
    };
    const editCharge = async item => {
      if (!item?.chargeId) return;
      await openPanel(item.chargeId);
    };
    const deleteCharge = async item => {
      if (!item || !item.chargeId) return;

      // Check if this is a child instance of a recurring series (not the parent)
      if (item.isRecurringSeries && !item.isParentRecurringCharge) {
        const deleteOption = await deleteRecurringRef.value?.open();
        if (!deleteOption) return; // User cancelled

        const mode = deleteOption === 'future' ? 'ThisAndFutureInstances' : 'ThisInstance';
        try {
          await chargesStore.deleteRecurring(item.chargeId, mode, true);
          handleSuccess(deleteOption === 'future' ? 'Recurring fees deleted successfully' : 'Fixed fee deleted successfully');
          await loadCharges();
        } catch (error) {
          // Error already handled by store
        }
        return;
      }

      // Non-recurring: use existing bulk delete flow
      selectedItems.value = [item.chargeId];
      await handleBulkDelete();
    };

    // Panel event handlers
    const handleCreateFixedFee = async () => {
      // Check for unsaved changes if panel is already open
      if (showEditPanel.value && editPanelRef.value?.confirmDiscardChanges) {
        const proceed = await editPanelRef.value.confirmDiscardChanges('creating a new one');
        if (!proceed) {
          return; // User chose to keep editing
        }

        // Close current panel before opening new
        showEditPanel.value = false;
        await nextTick();
      }

      // Clear all URL params first to ensure clean state for new charge
      if (props.state?.go) {
        props.state.go('fixedfees', {
          chargeId: undefined,
          panel: undefined,
          modal: undefined,
          matterId: undefined
        }, {
          notify: false,
          reload: false
        });
      }

      // Open panel for new charge
      clearPendingTimeout();
      selectedChargeId.value = null;
      selectedMatterId.value = null;
      showEditPanel.value = true;
    };
    const handlePanelClose = () => {
      showEditPanel.value = false;
      emit('panel-closed');

      // Keep selection visible briefly after closing
      closeTimeout.value = setTimeout(() => {
        selectedChargeId.value = null;
        selectedMatterId.value = null;
        closeTimeout.value = null;
      }, 300);
    };
    const handlePanelSaved = async fixedFee => {
      handleSuccess('Fixed fee saved successfully');
      showEditPanel.value = false;
      emit('panel-closed'); // Clear URL params after save
      // Reload table data
      await loadCharges();
      // Clear selection after reload
      selectedChargeId.value = null;
      selectedMatterId.value = null;
    };

    // Handle save-and-continue: only reload table, don't close panel or clear selection
    // Panel close/reopen is handled by openPanel() which triggered the save
    const handlePanelSavedAndContinue = async () => {
      // Reload table data to reflect saved changes
      await loadCharges();
    };
    const handleBulkDelete = async () => {
      if (selectedItems.value.length === 0) return;

      // Single-item checkbox selection: if the one selected fee is a child recurring instance,
      // route through the recurring delete dialog instead of the bulk flow
      if (selectedItems.value.length === 1) {
        const item = charges.value.find(c => c.chargeId === selectedItems.value[0]);
        if (item?.isRecurringSeries && !item?.isParentRecurringCharge) {
          await deleteCharge(item);
          clearSelection();
          return;
        }
      }
      deletionState.loading = true;
      deletionState.totalCount = selectedItems.value.length;
      deletionState.feesWithEntriesCount = 0;
      deletionState.billedCount = 0;
      deletionState.previewData = null;
      try {
        // Get deletion preview
        const preview = await chargesStore.getDeletionPreview(selectedItems.value);
        deletionState.previewData = preview;
        deletionState.feesWithEntriesCount = preview.charges?.filter(c => c.totalEntriesCount > 0).length || 0;
        deletionState.billedCount = preview.charges?.filter(c => c.billed).length || 0;
        deletionState.loading = false;

        // Open confirmation dialog and wait for user response
        const confirmed = await deleteConfirmRef.value?.open();
        if (confirmed) {
          await confirmDelete();
        }
      } catch (error) {
        deletionState.loading = false;
      }
    };
    const confirmDelete = async () => {
      deletionState.deleting = true;
      clearRowErrors(); // a new action starts clean

      try {
        // Call bulk delete with force=true to unassign entries
        const result = await chargesStore.bulkDeleteCharges(selectedItems.value, deletionState.feesWithEntriesCount > 0 // force=true if there are entries
        );

        // Show success message
        if (result.success) {
          handleSuccess(`Successfully deleted ${result.successCount} fixed fee(s)`);
        } else {
          // Partial success
          handleWarning(`Deleted ${result.successCount} of ${result.totalCount} fixed fees. ${result.errors?.length || 0} failed.`);
        }

        // Track bulk delete event
        if (props.tracking && result.successCount > 0) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEES, TrackingAction.BULK_OPERATION, {
            recordsUpdated: result.successCount,
            updateType: BulkUpdateType.DELETE,
            pageType: TrackingPageType.FIXED_FEE_LIST
          });
        }

        // Clear selection and reload data
        await loadCharges();
      } catch (error) {
        // Error already handled by store
      } finally {
        deletionState.deleting = false;
      }
    };
    const handlePrint = () => {
      window.print();
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_LIST, TrackingAction.PRINT, {
          recordCount: totalCount.value,
          filtersActive: hasActiveFilters.value,
          pageType: TrackingPageType.FIXED_FEE_LIST
        });
      }
    };
    const handleExport = () => {
      const params = buildTableParams();
      ChargeService.exportChargesTableUrl(params, props.leanLawAuth);
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_LIST, TrackingAction.EXPORT, {
          exportFormat: 'csv',
          recordCount: totalCount.value,
          filtersActive: hasActiveFilters.value,
          pageType: TrackingPageType.FIXED_FEE_LIST
        });
      }
    };

    // The server's own message is the toast; the per-fee reasons go inline on the
    // rows, where they outlive it. The next bulk action replaces them, a full success
    // clears them, and a page reload drops them.
    const notifyBulkResult = result => {
      handleResult(selectedItems.value, result?.errors, 'itemId', 'reason');
      if (result?.errors?.length) {
        handleWarning(result.message || 'Some fixed fees were skipped.', {
          timeout: 10000
        });
      } else {
        handleSuccess(result?.message || 'Bulk action complete.');
      }
    };
    const handleMarkComplete = async () => {
      if (selectedItems.value.length === 0) return;

      // Show confirmation dialog
      const confirmed = await completionConfirmRef.value?.open();
      if (confirmed) {
        await confirmCompletion();
      }
    };
    const confirmCompletion = async () => {
      clearRowErrors();
      try {
        // Always mark as complete
        const result = await chargesStore.bulkUpdateCompletion(selectedItems.value, CompletionState.Completed);
        notifyBulkResult(result);

        // Track bulk mark complete event
        if (props.tracking && result.successCount > 0) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEES, TrackingAction.BULK_OPERATION, {
            recordsUpdated: result.successCount,
            updateType: BulkUpdateType.MARK_COMPLETE,
            pageType: TrackingPageType.FIXED_FEE_LIST
          });
        }

        // Clear selection and reload data
        clearSelection();
        await loadCharges();
      } catch (error) {
        // Error already handled by store
      }
    };

    // Lock Time and Unlock Time share one endpoint and one summary — a single fee is
    // a list of one, which is why there is no row action to pair with (WF-005).
    const lockConfirmTitle = computed(() => {
      const fees = pluralizeWithCount(selectedItems.value.length, 'fixed fee');
      return pendingLockAction.value ? `Lock time on ${fees}?` : `Unlock time on ${fees}?`;
    });
    const lockConfirmMessage = computed(() => pendingLockAction.value ? "Time entries can't be added to or removed from locked fixed fees." :
    // BR-016: unlocking reopens the fee but does not un-bill anything already
    // marked, which is the part users do not expect.
    'Time entries can be added to unlocked fixed fees again. Any entries already marked Billed will remain Billed.');

    /** Returns false when the user backs out, so no request is made. */
    const confirmLockStatus = async timeLocked => {
      pendingLockAction.value = timeLocked;
      try {
        return (await lockConfirmRef.value?.open()) === true;
      } catch {
        return false;
      }
    };
    const applyLockStatus = async timeLocked => {
      if (selectedItems.value.length === 0 || bulkLockLoading.value) return;
      let result;
      bulkLockLoading.value = true;
      try {
        // The plain confirmation comes first because a lock with no WIP executes on
        // the very first request — there is no later point to ask.
        if (!(await confirmLockStatus(timeLocked))) return;
        clearRowErrors();
        result = await chargesStore.bulkUpdateLockStatus(selectedItems.value, timeLocked);

        // BR-012: with WIP on an eligible fee the server writes nothing and answers
        // with the counts instead (sc-48201), so this is the only lookup. The choice
        // goes back on a second request; cancelling here leaves every fee untouched.
        if (result?.requiresConfirmation) {
          const wipDisposition = await wipDispositionRef.value?.open({
            feeCount: result.chargesWithWipEntries?.length ?? 0,
            entryCount: result.totalWipEntryCount ?? 0
          });
          if (!wipDisposition) return;
          result = await chargesStore.bulkUpdateLockStatus(selectedItems.value, timeLocked, wipDisposition);
        }
      } catch (error) {
        return; // Error already handled by store
      } finally {
        bulkLockLoading.value = false;
      }

      // Outside the try: the fees are already locked, so a throw in the summary or
      // the tracker must not cost the user their toast and their table refresh.
      notifyBulkResult(result);
      if (props.tracking && result?.successCount > 0) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEES, TrackingAction.BULK_OPERATION, {
          recordsUpdated: result.successCount,
          updateType: timeLocked ? BulkUpdateType.LOCK_TIME : BulkUpdateType.UNLOCK_TIME,
          pageType: TrackingPageType.FIXED_FEE_LIST
        });
      }
      await loadCharges(); // clears the selection itself
    };
    const handleLockTime = () => applyLockStatus(true);
    const handleUnlockTime = () => applyLockStatus(false);
    const handleMarkIncomplete = async () => {
      if (selectedItems.value.length === 0) return;

      // Show confirmation dialog
      const confirmed = await incompletionConfirmRef.value?.open();
      if (confirmed) {
        await confirmIncompletion();
      }
    };
    const confirmIncompletion = async () => {
      clearRowErrors();
      try {
        // Mark as incomplete (NotCompleted = 0)
        const result = await chargesStore.bulkUpdateCompletion(selectedItems.value, CompletionState.NotCompleted);
        notifyBulkResult(result);

        // Track bulk mark incomplete event
        if (props.tracking && result.successCount > 0) {
          EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEES, TrackingAction.BULK_OPERATION, {
            recordsUpdated: result.successCount,
            updateType: BulkUpdateType.MARK_INCOMPLETE,
            pageType: TrackingPageType.FIXED_FEE_LIST
          });
        }

        // Clear selection and reload data
        clearSelection();
        await loadCharges();
      } catch (error) {
        // Error already handled by store
      }
    };

    // Change matter handlers
    const handleChangeMatter = () => {
      if (selectedItems.value.length === 0) return;
      changeMatterForm.value = {
        client: null,
        matter: null
      };
      showChangeMatterDialog.value = true;
    };
    const closeChangeMatterDialog = () => {
      showChangeMatterDialog.value = false;
      changeMatterForm.value = {
        client: null,
        matter: null
      };
      changeMatterState.requiresConfirmation = false;
      changeMatterState.totalUnbilledEntryCount = 0;
      changeMatterState.chargesWithUnbilledEntries = [];
    };
    const handleChangeMatterConfirm = async () => {
      if (!changeMatterForm.value.matter?.id) {
        handleError('Please select a target matter');
        return;
      }
      const targetMatterId = changeMatterForm.value.matter.id;
      const targetMatterName = changeMatterForm.value.matter.label || changeMatterForm.value.matter.name;
      try {
        const result = await ChargeService.bulkChangeMatter(selectedItems.value, targetMatterId, false);
        if (result.requiresConfirmation) {
          changeMatterState.totalUnbilledEntryCount = result.totalUnbilledEntryCount || 0;
          changeMatterState.chargesWithUnbilledEntries = result.chargesWithUnbilledEntries || [];
          showChangeMatterDialog.value = false;
          const confirmed = await changeMatterConfirmRef.value?.open();
          if (confirmed) {
            await executeChangeMatter(targetMatterId, targetMatterName, true);
          } else {
            closeChangeMatterDialog();
          }
          return;
        }
        await handleChangeMatterResult(result, targetMatterName);
      } catch (error) {
        handleError(error.response?.data?.message || error.message || 'Failed to change matter');
        closeChangeMatterDialog();
      }
    };
    const executeChangeMatter = async (targetMatterId, targetMatterName, confirmMoveEntries) => {
      clearRowErrors();
      try {
        const result = await ChargeService.bulkChangeMatter(selectedItems.value, targetMatterId, confirmMoveEntries);
        await handleChangeMatterResult(result, targetMatterName);
      } catch (error) {
        handleError(error.response?.data?.message || error.message || 'Failed to change matter');
      } finally {
        closeChangeMatterDialog();
      }
    };
    const handleChangeMatterResult = async (result, targetMatterName) => {
      if (result.success) {
        handleSuccess(`Successfully moved ${pluralizeWithCount(result.successCount, 'fixed fee')} to ${targetMatterName}`);
      } else if (result.successCount > 0) {
        handleWarning(`Moved ${result.successCount} of ${result.totalCount} fixed fees to ${targetMatterName}. ${result.errors?.length || 0} failed.`);
      } else {
        handleError(result.message);
      }

      // Track bulk change matter event
      if (props.tracking && result.successCount > 0) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEES, TrackingAction.BULK_OPERATION, {
          recordsUpdated: result.successCount,
          updateType: BulkUpdateType.CHANGE_MATTER,
          pageType: TrackingPageType.FIXED_FEE_LIST
        });
      }
      closeChangeMatterDialog();
      clearSelection();
      await loadCharges();
    };
    const clearSelection = () => {
      selectedItems.value = [];
    };

    // NOTE: hoursDecimal method is automatically available from main.js global utilities
    // DO NOT uncomment or redefine this method - it's already provided globally
    // const hoursDecimal = (input, showZero = true) => {

    // };

    // Check URL params and auto-open panel if needed
    const checkUrlParamsForPanel = () => {
      const chargeIdFromUrl = props.stateParams?.chargeId || props.state?.params?.chargeId;
      const panelFromUrl = props.stateParams?.panel || props.state?.params?.panel;
      if (chargeIdFromUrl && panelFromUrl === 'true') {
        selectedChargeId.value = chargeIdFromUrl;
        selectedMatterId.value = props.stateParams?.matterId || props.state?.params?.matterId || null;
        showEditPanel.value = true;
      }
    };

    // Lifecycle
    onMounted(async () => {
      await Promise.all([initializeColumnSettings(), loadCharges()]);
      // Check URL params after data is loaded
      checkUrlParamsForPanel();
    });
    onBeforeUnmount(() => {
      // Clear debounce timeout to prevent API calls after unmount
      if (saveTimeout.value) {
        clearTimeout(saveTimeout.value);
      }
      // Clear close timeout to prevent race condition
      if (closeTimeout.value) {
        clearTimeout(closeTimeout.value);
      }
    });

    // Expose methods for parent components
    __expose({
      loadCharges,
      editPanelRef
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      const _component_v_pagination = _resolveComponent("v-pagination");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_data_table = _resolveComponent("v-data-table");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(FixedFeesFilters, {
        tracking: props.tracking,
        onApplyFilters: handleApplyFilters,
        onClearFilters: handleClearFilters,
        onCreateFixedFee: handleCreateFixedFee,
        onFiltersVisibilityChanged: handleFiltersVisibilityChanged
      }, null, 8, ["tracking"])]), _unref(showMetabaseDashboard) && _unref(selectedDashboardId) ? (_openBlock(), _createBlock(MetabaseDashboard, {
        key: 0,
        dashboardId: _unref(selectedDashboardId),
        alerts: props.alerts,
        filters: _unref(dashboardFilters),
        minHeight: "500px",
        class: "mt-4 print:hidden"
      }, null, 8, ["dashboardId", "alerts", "filters"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
        modelValue: _unref(filterState).search,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _unref(filterState).search = $event), handleSearch],
        placeholder: "Search Fixed Fees",
        class: "max-w-md",
        "prepend-inner-icon": "mdi-magnify",
        "hide-details": ""
      }, {
        "prepend-inner": _withCtx(() => [_createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-magnify", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_v_menu, {
        "close-on-content-click": false,
        class: "print:hidden"
      }, {
        activator: _withCtx(({
          props: menuProps
        }) => [_createVNode(LlSecondaryButton, _mergeProps(menuProps, {
          variant: "outlined",
          size: "small",
          class: "text-capitalize flex-shrink-0",
          "append-icon": "mdi-chevron-down",
          "prepend-icon": "mdi-view-column",
          "data-cy": "fixed-fee-columns-menu-button"
        }), {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Columns ", -1)]))]),
          _: 1
        }, 16)]),
        default: _withCtx(() => [_createVNode(_component_v_list, {
          density: "compact",
          class: "py-0"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledColumnsList.value, column => {
            return _openBlock(), _createBlock(_component_v_list_item, {
              key: column.id,
              class: "d-print-none"
            }, {
              default: _withCtx(() => [_createVNode(LlCheckbox, {
                "model-value": isColumnVisible(column.id),
                "onUpdate:modelValue": $event => toggleColumn(column.id, $event),
                label: getColumnLabel(column),
                labelClass: 'text-sm',
                density: "compact",
                "data-cy": `column-toggle-${column.id}`
              }, null, 8, ["model-value", "onUpdate:modelValue", "label", "data-cy"])]),
              _: 2
            }, 1024);
          }), 128)), enabledColumnsList.value.length > 0 && disabledColumnsList.value.length > 0 ? (_openBlock(), _createElementBlock("hr", _hoisted_7)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disabledColumnsList.value, column => {
            return _openBlock(), _createBlock(_component_v_list_item, {
              key: column.id,
              class: "d-print-none"
            }, {
              default: _withCtx(() => [_createVNode(LlCheckbox, {
                "model-value": isColumnVisible(column.id),
                "onUpdate:modelValue": $event => toggleColumn(column.id, $event),
                label: getColumnLabel(column),
                labelClass: 'text-sm',
                density: "compact",
                "data-cy": `column-toggle-${column.id}`
              }, null, 8, ["model-value", "onUpdate:modelValue", "label", "data-cy"])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        size: "small",
        variant: "outlined",
        class: "w-full sm:w-auto",
        "append-icon": "mdi-printer",
        onClick: handlePrint
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        size: "small",
        variant: "outlined",
        class: "w-full sm:w-auto",
        "append-icon": "mdi-download",
        onClick: handleExport,
        disabled: selectedItems.value.length > 0 || charges.value.length === 0 || exportLoading.value
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Export ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_v_pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => currentPage.value = $event),
        length: totalPages.value || 0,
        "total-visible": 3,
        density: "compact",
        onClick: loadCharges,
        "hide-details": "true",
        class: "flex-shrink-0"
      }, null, 8, ["modelValue", "length"])])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_withDirectives(_createVNode(LlStatusBadge, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(pluralizeWithCount)(selectedItems.value.length, 'fixed fee')) + " selected ", 1)]),
        _: 1
      }, 512), [[_vShow, selectedItems.value.length > 0]])]), _createElementVNode("div", _hoisted_10, [!fixedFeeTimeLockEnabled.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "primary",
        disabled: selectedItems.value.length === 0,
        onClick: handleMarkComplete
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Mark Complete ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "orange-darken-1",
        disabled: selectedItems.value.length === 0,
        onClick: handleMarkIncomplete
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Mark Incomplete ", -1)]))]),
        _: 1
      }, 8, ["disabled"])], 64)) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        "prepend-icon": "mdi-swap-horizontal",
        disabled: selectedItems.value.length === 0,
        onClick: handleChangeMatter,
        "data-cy": "change-matter-button"
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Change Matter ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "error",
        "prepend-icon": "mdi-delete",
        disabled: selectedItems.value.length === 0,
        onClick: handleBulkDelete
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Delete ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), fixedFeeTimeLockEnabled.value ? (_openBlock(), _createBlock(FixedFeeBulkActionsMenu, {
        key: 1,
        "selected-count": selectedItems.value.length,
        loading: loading.value || bulkLockLoading.value,
        "show-lock-actions": canLockUnlockTime.value,
        onMarkComplete: handleMarkComplete,
        onMarkIncomplete: handleMarkIncomplete,
        onLockTime: handleLockTime,
        onUnlockTime: handleUnlockTime
      }, null, 8, ["selected-count", "loading", "show-lock-actions"])) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        disabled: selectedItems.value.length === 0,
        onClick: clearSelection
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Clear selection ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_v_data_table, {
        modelValue: selectedItems.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectedItems.value = $event),
        "sort-by": sortBy.value,
        headers: visibleHeaders.value,
        items: charges.value,
        loading: loading.value,
        "items-per-page": pageSize.value,
        page: currentPage.value,
        "item-value": "chargeId",
        "show-select": "",
        class: "fixed-fees-table",
        density: "comfortable",
        hover: "",
        "hide-default-footer": "",
        "fixed-header": "",
        height: tableHeight.value,
        "must-sort": true,
        "onUpdate:sortBy": handleSortChange,
        "onClick:row": handleRowClick,
        "row-props": getRowProps
      }, {
        "item.clientName": _withCtx(({
          item
        }) => [_createElementVNode("a", {
          href: "#",
          class: "text-gray-900 text-sm font-medium hover:underline",
          onClick: _withModifiers($event => goToClient(item.clientId), ["prevent"])
        }, _toDisplayString(_unref(formatOrDefault)(item.clientName)), 9, _hoisted_12)]),
        "item.matterName": _withCtx(({
          item
        }) => [_createElementVNode("a", {
          href: "#",
          class: "text-gray-900 text-sm font-medium hover:underline",
          onClick: _withModifiers($event => goToMatter(item.clientId, item.matterId), ["prevent"])
        }, _toDisplayString(_unref(formatOrDefault)(item.matterName)), 9, _hoisted_13)]),
        "item.amount": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatCurrency)(item.amount)), 1)]),
        "item.chargeType": _withCtx(({
          item
        }) => [_createVNode(_component_v_chip, {
          color: "grey-darken-3",
          size: "small",
          variant: "outlined",
          class: "rounded font-normal text-gray-300 border-gray-100"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatChargeType)(item.chargeType)), 1)]),
          _: 2
        }, 1024)]),
        "item.profitability": _withCtx(({
          item
        }) => [canViewRates.value && item.profitability != null ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", {
          class: _normalizeClass([_unref(getProfitabilityColor)(item.profitability), "font-semibold text-sm"])
        }, _toDisplayString(_unref(formatPercentage)(item.profitability)), 3), _createVNode(_component_v_icon, {
          icon: item.profitability >= 0 ? 'mdi-arrow-up' : 'mdi-arrow-down',
          color: item.profitability >= 0 ? 'success' : 'error',
          size: "16"
        }, null, 8, ["icon", "color"])])) : (_openBlock(), _createElementBlock("span", _hoisted_16, "—"))]),
        "item.profitabilityAmount": _withCtx(({
          item
        }) => [canViewRates.value && item.profitabilityAmount != null ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(formatCurrency)(item.profitabilityAmount)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))]),
        "item.label": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatOrDefault)(item.label, '')), 1)]),
        "item.matterReference": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formatOrDefault)(item.matterReference, '')), 1)]),
        "item.description": _withCtx(({
          item
        }) => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatOrDefault)(item.description || item.label, '')), 1), _unref(getRowState)(item.chargeId).error ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(LlIcon, {
          icon: "mdi-alert",
          size: "14",
          color: "warning",
          class: "flex-shrink-0"
        }), _createTextVNode(" " + _toDisplayString(_unref(getRowState)(item.chargeId).error), 1)])) : _createCommentVNode("", true)])]),
        "item.chargeId": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_23, _toDisplayString(_unref(formatOrDefault)(item.chargeId)), 1)]),
        "item.billedState": _withCtx(({
          item
        }) => [_createVNode(_component_v_chip, {
          color: _unref(getStatusColor)(item.billedState),
          size: "small",
          variant: "flat",
          class: "font-normal"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatBilledStatus)(item.billedState)), 1)]),
          _: 2
        }, 1032, ["color"])]),
        [`item.timeLocked`]: _withCtx(({
          item
        }) => [_createVNode(LlTooltip, {
          text: item.timeLocked ? 'Time Locked' : 'Time Unlocked',
          location: "top"
        }, {
          activator: _withCtx(({
            props: tipProps
          }) => [_createElementVNode("span", _mergeProps(tipProps, {
            role: "img",
            "aria-label": item.timeLocked ? 'Time Locked' : 'Time Unlocked',
            "data-cy": "time-lock-status-icon"
          }), [_createVNode(LlIcon, {
            icon: item.timeLocked ? 'mdi-lock' : 'mdi-lock-open',
            color: item.timeLocked ? 'grey-darken-1' : 'green-darken-1',
            size: "18"
          }, null, 8, ["icon", "color"])], 16, _hoisted_24)]),
          _: 2
        }, 1032, ["text"])]),
        "item.completionState": _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_25, [!item.completionState ? (_openBlock(), _createElementBlock("span", _hoisted_26, "—")) : (_openBlock(), _createBlock(_component_v_chip, {
          key: 1,
          color: _unref(getCompletionColor)(item.completionState),
          size: "small",
          variant: "flat",
          class: "font-medium"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatStatus)(item.completionState)), 1)]),
          _: 2
        }, 1032, ["color"]))])]),
        "item.customFlag": _withCtx(({
          item
        }) => [_createVNode(_component_v_icon, {
          icon: item.customFlag ? 'fa-check-circle' : 'fa-circle',
          color: item.customFlag ? 'primary' : 'default',
          size: "small"
        }, null, 8, ["icon", "color"])]),
        "item.hours": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.hoursDecimal(item.hours) || ''), 1)]),
        "item.activityCode": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatOrDefault)(item.activityCode)), 1)]),
        "item.taskCode": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_29, _toDisplayString(_unref(formatOrDefault)(item.taskCode)), 1)]),
        "item.invoiceUser": _withCtx(({
          item
        }) => [_createVNode(LlUserAvatar, {
          initials: item.invoiceUserInitials,
          name: item.invoiceUser
        }, null, 8, ["initials", "name"])]),
        "item.chargeDate": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(getShortDateString)(item.chargeDateDisplay)), 1)]),
        "item.createdDate": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_31, _toDisplayString(_unref(getShortDateString)(item.createdDate)), 1)]),
        "item.actions": _withCtx(({
          item
        }) => [_createVNode(_component_v_menu, null, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlSecondaryButton, _mergeProps({
            icon: "mdi-dots-vertical",
            variant: "text",
            size: "small"
          }, props, {
            density: "comfortable",
            "aria-label": "Fixed fee actions"
          }), null, 16)]),
          default: _withCtx(() => [_createVNode(_component_v_list, {
            density: "compact"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item, {
              onClick: $event => viewDetails(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("View Details", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_v_list_item, {
              onClick: $event => editCharge(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("Edit", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_v_list_item, {
              onClick: $event => deleteCharge(item),
              class: "text-error"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Delete", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["onClick"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        loading: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_v_skeleton_loader, {
          type: "table-row@13",
          class: "w-full"
        })])]),
        "no-data": _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_v_icon, {
          icon: "fa-file-invoice-dollar",
          size: "64",
          color: "grey-lighten-2",
          class: "mb-4"
        }), _cache[17] || (_cache[17] = _createElementVNode("p", {
          class: "text-xl font-medium text-gray-600 mb-2"
        }, " No fixed fees found ", -1)), _cache[18] || (_cache[18] = _createElementVNode("p", {
          class: "text-gray-500"
        }, " Try adjusting your search or filters ", -1))])]),
        _: 2
      }, 1032, ["modelValue", "sort-by", "headers", "items", "loading", "items-per-page", "page", "height"])])])]), _createVNode(LlConfirmationDialog, {
        ref_key: "deleteConfirmRef",
        ref: deleteConfirmRef,
        title: "Delete Selected Fees?",
        message: deletionConfirmMessage.value,
        "toggle-text": "Cancel",
        "confirm-text": deletionState.feesWithEntriesCount > 0 ? 'Continue' : 'Delete',
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "delete-fees-confirmation"
      }, null, 8, ["message", "confirm-text"]), _createVNode(DeleteRecurringFeesDialog, {
        ref_key: "deleteRecurringRef",
        ref: deleteRecurringRef
      }, null, 512), _createVNode(FixedFeeEditPanel, {
        modelValue: showEditPanel.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showEditPanel.value = $event),
        chargeId: selectedChargeId.value,
        matterId: selectedMatterId.value,
        state: props.state,
        stateParams: props.stateParams,
        rootScope: props.rootScope,
        alerts: props.alerts,
        snippetService: props.snippetService,
        entryEditService: props.entryEditService,
        tracking: props.tracking,
        clientMatterManager: props.clientMatterManager,
        entryPoint: "fixed_fee_list",
        onSaved: handlePanelSaved,
        onSavedAndContinue: handlePanelSavedAndContinue,
        onClosed: handlePanelClose,
        ref_key: "editPanelRef",
        ref: editPanelRef
      }, null, 8, ["modelValue", "chargeId", "matterId", "state", "stateParams", "rootScope", "alerts", "snippetService", "entryEditService", "tracking", "clientMatterManager"]), _createVNode(LlConfirmationDialog, {
        ref_key: "completionConfirmRef",
        ref: completionConfirmRef,
        title: "Mark Selected Fees as Complete?",
        message: completionConfirmMessage.value,
        "toggle-text": "Cancel",
        "confirm-text": "Continue",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "completion-fees-confirmation"
      }, null, 8, ["message"]), _createVNode(LlConfirmationDialog, {
        ref_key: "incompletionConfirmRef",
        ref: incompletionConfirmRef,
        title: "Mark Selected Fees as Incomplete?",
        message: incompletionConfirmMessage.value,
        "toggle-text": "Cancel",
        "confirm-text": "Continue",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "incompletion-fees-confirmation"
      }, null, 8, ["message"]), _createVNode(FixedFeeWipDispositionDialog, {
        ref_key: "wipDispositionRef",
        ref: wipDispositionRef
      }, null, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "lockConfirmRef",
        ref: lockConfirmRef,
        title: lockConfirmTitle.value,
        message: lockConfirmMessage.value,
        "toggle-text": "Cancel",
        "confirm-text": pendingLockAction.value ? 'Lock time' : 'Unlock time',
        "confirm-color": "primary",
        "data-cy": "lock-status-confirmation"
      }, null, 8, ["title", "message", "confirm-text"]), _createVNode(ChangeMatterDialog, {
        modelValue: showChangeMatterDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showChangeMatterDialog.value = $event),
        "selected-count": selectedItems.value.length,
        "matter-form": changeMatterForm.value,
        onConfirm: handleChangeMatterConfirm,
        onCancel: closeChangeMatterDialog
      }, null, 8, ["modelValue", "selected-count", "matter-form"]), _createVNode(LlConfirmationDialog, {
        ref_key: "changeMatterConfirmRef",
        ref: changeMatterConfirmRef,
        title: "Move Fixed Fees with Time Entries",
        message: changeMatterConfirmMessage.value,
        "toggle-text": "Cancel",
        "confirm-text": "Continue",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "change-matter-confirmation"
      }, null, 8, ["message"])]);
    };
  }
};